import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { RELAY_DELIVERY_METHOD } from 'common/constants/relayOrders';

import formatRelayQuantity from '../utils/relayQuantity';

/**
 * POM-6099 — a relay order's line items. Presentational only: props in, markup out, no Redux, so
 * the Non-Routable fax detail view can render the same table.
 *
 * No Rx Reference column, by design (POM-6099 UI review).
 *
 * POM-6279 P5: a FAX relay has no Quello script, so that column is dropped for one rather than
 * rendered N/A on every line. Without `deliveryMethod` (or with an unknown one) the table is as it
 * was, which keeps the Non-Routable fax detail view's usage unchanged.
 */
const RelayLineItemsTable = ({ lineItems, deliveryMethod }) => {
  const showVendorScript = deliveryMethod !== RELAY_DELIVERY_METHOD.FAX;

  return (
    <Table size='small' sx={{ mt: 2 }} aria-label='relayed order line items'>
      <TableHead>
        <TableRow>
          <TableCell>#</TableCell>
          <TableCell>Drug</TableCell>
          {/* NDC hidden for now (POM-6279 QA). */}
          <TableCell>Qty</TableCell>
          {showVendorScript && <TableCell>Quello Script</TableCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {lineItems.map((item) => (
          <TableRow key={item.relayLineItemId}>
            <TableCell>{item.ordinal}</TableCell>
            <TableCell>{item.drugName || 'N/A'}</TableCell>
            <TableCell>{formatRelayQuantity(item.quantity)}</TableCell>
            {showVendorScript && <TableCell>{item.vendorScriptNumber || 'N/A'}</TableCell>}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

RelayLineItemsTable.propTypes = {
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      relayLineItemId: PropTypes.string.isRequired,
      ordinal: PropTypes.number,
      drugName: PropTypes.string,
      ndc: PropTypes.string,
      quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      vendorScriptNumber: PropTypes.string,
    })
  ),
  deliveryMethod: PropTypes.string,
};

RelayLineItemsTable.defaultProps = { lineItems: [], deliveryMethod: undefined };

export default RelayLineItemsTable;
